import { Button, Spinner } from './ui';

// The all / by-amount scoring control set, shared by Lead Score and Contacts
// (Phase 11). Individual (per-row) scoring lives on the row itself. While a run is
// in flight it shows the X-of-Y progress bar instead of the buttons, and the
// buttons are disabled — the caller also disables its completion/nav actions.
export function ScoreControls({
  scoring, progress, unscored, onAll, onAmount, label = 'Score',
}: {
  scoring: boolean;
  progress: { done: number; total: number } | null;
  unscored: number;
  onAll: () => void;
  onAmount: (n: number) => void;
  label?: string;
}) {
  if (progress) {
    const pct = Math.round((progress.done / Math.max(1, progress.total)) * 100);
    return (
      <div className="rounded-xl border border-electric/40 bg-electric/5 px-3.5 py-3">
        <div className="flex items-center justify-between text-sm font-semibold text-electric">
          <span className="flex items-center gap-2"><Spinner className="h-4 w-4" /> Scoring…</span>
          <span>{progress.done} of {progress.total}</span>
        </div>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-surface-3">
          <div className="h-full rounded-full bg-electric transition-all" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }
  if (!unscored) return <span className="text-xs text-muted">All scored</span>;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-xs text-muted">{label}:</span>
      <Button variant="ghost" disabled={scoring} onClick={onAll} className="px-2.5 py-1 text-sm">All {unscored}</Button>
      {unscored > 20 && <Button variant="ghost" disabled={scoring} onClick={() => onAmount(20)} className="px-2.5 py-1 text-sm">Next 20</Button>}
      {unscored > 50 && <Button variant="ghost" disabled={scoring} onClick={() => onAmount(50)} className="px-2.5 py-1 text-sm">Next 50</Button>}
    </div>
  );
}
